export default objects => objects[0]?.previousElementSibling
